import styles from "./ActionLogs.module.css";
import { Timeline, Popover, Whisper } from "rsuite";
import { Badge } from "rsuite";
import MessageModal from "./Components/MessageModal/MessageModal";
import { useMessageModal } from "./Components/MessageModal/useMessageModal";
import { fn } from "moment";

function timeConvert(isoDateString) {
  if (!isoDateString) return "";

  //   // Check if already in DD/MM/YYYY HH:mm format
  //   const dateTimePattern = /^\d{2}\/\d{2}\/\d{4}\s+\d{2}:\d{2}/;
  //   if (dateTimePattern.test(isoDateString.trim())) {
  //     return isoDateString.trim();
  //   }

  const date = new Date(isoDateString);

  // Check if date is valid
  if (isNaN(date.getTime())) {
    return isoDateString; // Return original if conversion failed
  }

  // Get date components
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  // Get time components
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

function ActionLogs({ actions }) {
  const { showMessageModal } = useMessageModal();

  const MessageButton = (
    <>
      <span className={styles.messageButton} onClick={showMessageModal}>
        Message
      </span>
    </>
  );

  return (
    <>
      <div className={styles.container}>
        <div className={styles.title}>Action History</div>
        <div style={{ height: "20px" }}></div>
        <Timeline>
          {actions.map((action) => (
            <>
              <Timeline.Item
                key={`${action.actionName} by ${action.user} on ${action.time}`}
              >
                <div>
                  {`${action.actionName} by ${action.user} on ${timeConvert(
                    action.time
                  )}`}
                  &nbsp; &nbsp;
                  {action?.message && (
                    <ActionMessage message={action?.message} />
                  )}
                </div>
              </Timeline.Item>
            </>
          ))}
        </Timeline>
      </div>
    </>
  );
}

export default ActionLogs;

function ActionMessage({ message }) {
  const tooltip = <Popover>{message}</Popover>;

  return (
    <>
      <Whisper
        placement="topStart"
        controlId="control-id-hover"
        trigger="hover"
        speaker={tooltip}
      >
        <span className={styles.messageButton}> Message </span>
      </Whisper>
    </>
  );
}
